import { v1 as uuid, } from 'uuid'
import moment from 'moment'

import megaTripData from 'temp/megaTripData'
import otherTripData from 'temp/otherTripData'
import sriLankaTripData from 'temp/sriLankaTripData'

import * as actionTypes from 'redux/actions/actionTypes'

// function hackSelectedTripId() {
//   return 'gem-russ-south-america-2017'
//   if (window.location.href.indexOf('gem-russ') > -1){
//     return 'gem-russ-south-america-2017'
//   } else {
//     return 'sri-lanka-2018'
//   }
// }

const defaultTripData = {
  // hack in our trip as default, for feature parity with current site
  // selectedTripId: 'gem-russ-south-america-2017',
  // selectedTripId: 'other-random-trip',
  // selectedTripId: hackSelectedTripId(),
  selectedTripId: 'sri-lanka-2018',
  selectedEventId: undefined,
  addingTrip: false,
  editingTrip: false,
  selectedEventInfoDisplayed: false,
  selectedEventInfoDayMediaDisplayed: false,
  listingMode: false,
  tripData: {
    'gem-russ-south-america-2017': {
      name: 'Gem & Russ South America 2017',
      events: megaTripData.events,
      media: megaTripData.media,
    },
    // 'other-random-trip': {
    //   name: 'Other Random Trip',
    //   events: otherTripData.events,
    //   media: otherTripData.media,
    // },
    'sri-lanka-2018': {
      name: 'Sri Lanka 2018',
      events: sriLankaTripData.events,
      media: sriLankaTripData.media,
    },
  },
}

const tripsReducer = (state = defaultTripData, action) => {
  switch (action.type) {
    // *** NAV REDUCERS ***

    case actionTypes.LOCATION_HOME: {
      return {
        ...state,
        selectedTripId: defaultTripData.selectedTripId,
        selectedEventId: undefined,
        addingTrip: false,
        editingTrip: false,
        selectedEventInfoDisplayed: false,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: false,
      }
    }

    case actionTypes.LOCATION_ADD_TRIP: {
      return {
        ...state,
        addingTrip: true,
        editingTrip: false,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: undefined,
        selectedEventInfoDisplayed: false,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_AS_LIST: {
      return {
        ...state,
        selectedTripId: action.payload.tripId,
        selectedEventId: undefined,
        selectedEventInfoDisplayed: false,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: true,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_AS_MAP: {
      return {
        ...state,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_EDIT_TRIP: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: true,
        selectedTripId: action.payload.tripId,
        selectedEventId: undefined,
        selectedEventInfoDisplayed: false,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_EVENT: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: action.payload.eventId,
        selectedEventInfoDisplayed: false,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_EVENT_INFO: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: action.payload.eventId,
        selectedEventInfoDisplayed: true,
        selectedEventInfoDayMediaDisplayed: false,
        listingMode: false,
      }
    }

    // TODO factor out the LIST non-List modes in to grouped case selectors

    case actionTypes.LOCATION_VIEW_TRIP_LIST_EVENT_INFO: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: action.payload.eventId,
        selectedEventInfoDayMediaDisplayed: false,
        selectedEventInfoDisplayed: true,
        listingMode: true,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_EVENT_INFO_DAY_MEDIA: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: action.payload.eventId,
        selectedEventDayNum: action.payload.dayNum,
        selectedEventMediaId: action.payload.mediaId,
        selectedEventMediaType: action.payload.mediaType,
        selectedEventInfoDayMediaDisplayed: true,
        selectedEventInfoDisplayed: true,
        listingMode: false,
      }
    }
    case actionTypes.LOCATION_VIEW_TRIP_LIST_EVENT_INFO_DAY_MEDIA: {
      return {
        ...state,
        addingTrip: false,
        editingTrip: false,
        selectedTripId: action.payload.tripId,
        selectedEventId: action.payload.eventId,
        selectedEventDayNum: action.payload.dayNum,
        selectedEventMediaId: action.payload.mediaId,
        selectedEventMediaType: action.payload.mediaType,
        selectedEventInfoDayMediaDisplayed: true,
        selectedEventInfoDisplayed: true,
        listingMode: true,
      }
    }
    // *** GENERAL REDUCERS ***

    case actionTypes.ACTION_CREATE_NEW_TRIP: {
      return {
        ...state,
        tripData: {
          ...state.tripData,
          [action.payload.tripId]: action.payload.tripData,
        },
      }
    }
    case actionTypes.ACTION_ADD_TRIP_LOCATION: {
      // add new location and update the 'to' information of the previous
      // event

      // TODO: insert location in to relevant place and amend relevant surrounding dates

      // TODO: show/hold/display any resulting removed itinerary items (maybe in a confirm dialogue?)

      const newTripData = { ...state.tripData[action.payload.tripId], }
      const newLocation = { ...action.payload.location, }
      newLocation.id = uuid()
      const { events, } = newTripData
      const lastEventIndex = events.length - 1
      const lastEvent = { ...events[lastEventIndex], }
      lastEvent.to = action.payload.to.slice(0)
      newTripData.events[lastEventIndex] = lastEvent
      newTripData.events.push(newLocation)
      return {
        ...state,
        tripData: {
          ...state.tripData,
          [action.payload.tripId]: newTripData,
        },
      }
    }
    case actionTypes.ACTION_UPDATE_TRIP_LOCATION: {
      const newTripData = { ...state.tripData[action.payload.tripId], }
      // apply new location data
      let locationIndex
      newTripData.events.forEach((location, index) => {
        if (location.id === action.payload.location.id) {
          locationIndex = index
        }
      })
      newTripData.events[locationIndex] = action.payload.location
      const thisStart =
        action.payload.location.arrive || action.payload.location.depart
      const previousLocation = newTripData.events[locationIndex - 1]
      // update the departure date of the 'to' jounrey type array of the previous location
      if (previousLocation && previousLocation.to) {
        previousLocation.to.forEach((journey, index) => {
          previousLocation.to[index].departureDate = thisStart
        })
      }
      // update the 'itinerary' array of the previous location
      if (previousLocation && previousLocation.itinerary) {
        const prevStart = previousLocation.arrive || previousLocation.depart
        const daysBetween = moment(thisStart).diff(moment(prevStart), 'days')
        if (previousLocation.itinerary.length > daysBetween + 1) {
          // TODO show the user what itinerary items were removed?
          previousLocation.itinerary = previousLocation.itinerary.slice(
            0,
            daysBetween + 1
          )
        }
      }
      return {
        ...state,
        tripData: {
          ...state.tripData,
          [action.payload.tripId]: newTripData,
        },
      }
    }
    case actionTypes.ACTION_UPDATE_TRIP_ITINERARY: {
      const newEvents = state.tripData[action.payload.tripId].events.slice(0)
      newEvents.forEach((location, index) => {
        if (location.id === action.payload.locationId) {
          newEvents[index].itinerary = action.payload.itinerary.slice(0)
        }
      })
      return {
        ...state,
        tripData: {
          ...state.tripData,
          [action.payload.tripId]: {
            ...state.tripData[action.payload.tripId],
            events: newEvents,
          },
        },
      }
    }
    default:
      return state
  }
}

export default tripsReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/tripsReducer.js